import Types from "./types";
import { CarService } from "../../../service/car-service";
import { resetReducerKeys } from "../../../constants/reset-reducer-constant";

const updatePincodeSelection = (selectedPincode) => ({
    type: Types.UPDATE_PINCODE_SELECTION,
    selectedPincode
});

const updateIsSubmitted = (isSubmitted) => ({
    type: Types.UPDATE_IS_SUBMITTED,
    isSubmitted
});

const submitOnBoarding = (params) => () => {
    return new Promise((resolve) => {
        CarService.submitOnBoarding(params)
            .then(response => resolve(response));
    });
};

const updateDealerName = (dealerName) => ({
    type: Types.UPDATE_DEALER_NAME,
    dealerName
});

const resetPartnerSelections = () => ({
    type: resetReducerKeys.RESET_PARTNER_FORM
});

export {
    updatePincodeSelection,
    updateIsSubmitted,
    submitOnBoarding,
    updateDealerName,
    resetPartnerSelections
};
